// extracted by mini-css-extract-plugin
export default {"hoverButton":"header_hoverButton__HxB-G","parent":"header_parent__4CY92","links":"header_links__S1R8T","list":"header_list__flCac","linklist":"header_linklist__IRyO3"};